<template>
  <main class="config-page">
    <header class="hero">
      <button class="back" @click="$router.push('/AdminAgentes/' + agenteId)">← Voltar ao agente</button>
      <div>
        <small>ADMIN CLIENTE · AGENTE INTERATIVO</small>
        <h1>Configuração do agente</h1>
        <p>Defina comportamento, integrações e limites de atendimento.</p>
      </div>
      <label class="active"><input v-model="form.ativo" type="checkbox" /> Agente interativo ativo</label>
    </header>

    <div v-if="aviso.texto" :class="['notice', aviso.tipo]">{{ aviso.texto }}</div>
    <div v-if="carregando" class="loading">Carregando configuração...</div>

    <form v-else @submit.prevent="salvar">
      <section class="panel prompt-panel">
        <div class="title"><span class="icon"><i class="mdi mdi-account-voice"></i></span><div><h2>Identidade e comportamento</h2><p>Estas instruções orientam a IA em todas as conversas.</p></div></div>
        <label>Prompt principal
          <textarea v-model="form.prompt" rows="18" placeholder="Cole aqui as instruções do agente: identidade, tom de voz, etapas de atendimento, regras, limites e quando transferir para um humano."></textarea>
          <small>{{ (form.prompt || '').length.toLocaleString('pt-BR') }} caracteres</small>
        </label>
      </section>

      <section class="panel">
        <div class="title"><span class="icon"><i class="mdi mdi-connection"></i></span><div><h2>Integrações</h2><p>Vínculos utilizados pelo workflow do agente.</p></div></div>
        <div class="grid three">
          <label>Instância Evolution<input v-model.trim="form.instancia" required placeholder="avance_comercial01" /></label>
          <label>Modelo OpenAI<input v-model.trim="form.modeloOpenAi" placeholder="gpt-4.1-mini" /></label>
          <label>Calendar ID<input v-model.trim="form.calendarId" placeholder="contato@empresa.com.br" /></label>
          <label>Fuso horário<input v-model.trim="form.fusoHorario" placeholder="America/Sao_Paulo" /></label>
        </div>
      </section>

      <section class="panel">
        <div class="title"><span class="icon"><i class="mdi mdi-calendar-clock"></i></span><div><h2>Agenda</h2><p>Regras usadas para oferecer e reservar reuniões.</p></div></div>
        <div class="grid four">
          <label>Duração (min)<input v-model.number="form.duracaoReuniaoMin" type="number" min="5" /></label>
          <label>Intervalo (min)<input v-model.number="form.intervaloReuniaoMin" type="number" min="0" /></label>
          <label>Antecedência (min)<input v-model.number="form.antecedenciaMin" type="number" min="0" /></label>
          <label>Dias futuros<input v-model.number="form.diasFuturos" type="number" min="1" /></label>
        </div>
        <label>Horários disponíveis (JSON)
          <textarea v-model="form.horariosJson" rows="5" spellcheck="false" placeholder='{"QUARTA":[["09:00","12:00"],["13:00","19:00"]]}'></textarea>
          <small>Informe os dias e suas faixas de atendimento. O JSON é validado antes de salvar.</small>
        </label>
      </section>

      <section class="panel">
        <div class="title"><span class="icon"><i class="mdi mdi-message-processing-outline"></i></span><div><h2>Conversa e resposta</h2><p>Tempo de agrupamento, memória e tamanho das mensagens.</p></div></div>
        <div class="grid three">
          <label>Debounce texto (seg)<input v-model.number="form.debounceTextoSeg" type="number" min="0" /></label>
          <label>Debounce mídia (seg)<input v-model.number="form.debounceMidiaSeg" type="number" min="0" /></label>
          <label>Mensagens no histórico<input v-model.number="form.historicoMensagens" type="number" min="1" /></label>
          <label>Caracteres por mensagem<input v-model.number="form.maxCaracteresBalao" type="number" min="100" /></label>
          <label>Máximo de mensagens por resposta<input v-model.number="form.maxBaloesResposta" type="number" min="1" /></label>
        </div>
      </section>

      <footer class="actions"><button type="button" class="secondary" @click="carregar">Descartar alterações</button><button class="primary" :disabled="salvando">{{ salvando ? 'Salvando...' : 'Salvar configuração' }}</button></footer>
    </form>
  </main>
</template>

<script>
import axios from "axios";

const inicial = () => ({
  instancia: "", modeloOpenAi: "gpt-4.1-mini", colecaoQdrant: "", prompt: "",
  calendarId: "", fusoHorario: "America/Sao_Paulo", horariosJson: "",
  duracaoReuniaoMin: 30, intervaloReuniaoMin: 15, antecedenciaMin: 120,
  diasFuturos: 30, debounceTextoSeg: 5, debounceMidiaSeg: 8,
  historicoMensagens: 20, maxCaracteresBalao: 500, maxBaloesResposta: 3, ativo: true,
});

export default {
  name: "ConfiguracaoAgenteView",
  data: () => ({ form: inicial(), carregando: true, salvando: false, aviso: { texto: "", tipo: "" } }),
  computed: { agenteId() { return this.$route.params.id; } },
  mounted() { this.carregar(); },
  methods: {
    valor(o, nome) { return o?.[nome] ?? o?.[nome[0].toUpperCase() + nome.slice(1)]; },
    async carregar() {
      this.carregando = true; this.aviso = { texto: "", tipo: "" };
      try {
        const x = (await axios.get(`/Process/AdminAgentes/Interativos/Configuracoes/${this.agenteId}`)).data;
        const base = inicial();
        if (x) Object.keys(base).forEach(k => { const v = this.valor(x, k); if (v !== undefined && v !== null) base[k] = v; });
        this.form = base;
      } catch (e) { this.aviso = { texto: this.erro(e, "Não foi possível carregar a configuração."), tipo: "error" }; }
      finally { this.carregando = false; }
    },
    async salvar() {
      if (this.form.horariosJson?.trim()) {
        try { JSON.parse(this.form.horariosJson); }
        catch { this.aviso = { texto: "Os horários disponíveis não contêm um JSON válido.", tipo: "error" }; return; }
      }
      this.salvando = true; this.aviso = { texto: "", tipo: "" };
      try {
        await axios.post(`/Process/AdminAgentes/Interativos/Configuracoes/${this.agenteId}/Salvar`, this.form);
        this.aviso = { texto: "Configuração salva com sucesso.", tipo: "success" };
      } catch (e) { this.aviso = { texto: this.erro(e, "Não foi possível salvar a configuração."), tipo: "error" }; }
      finally { this.salvando = false; window.scrollTo({ top: 0, behavior: "smooth" }); }
    },
    erro(e, padrao) { const d = e?.response?.data; return typeof d === "string" ? d : d?.mensagem || d?.message || padrao; },
  },
};
</script>

<style scoped>
.config-page{min-height:100vh;background:#f3f6f8;padding:25px;color:#122235}.hero{display:grid;grid-template-columns:auto 1fr auto;gap:24px;align-items:center;background:linear-gradient(120deg,#183b49,#286d68);color:#fff;padding:26px;border-radius:16px}.hero h1{color:#fff!important;font-size:34px;margin:3px 0}.hero p{margin:0}.hero small{color:#79e0dc;font-weight:800;letter-spacing:.08em}.back{border:0;background:transparent;color:#fff;font-weight:700;white-space:nowrap}.active{display:flex;gap:9px;align-items:center;padding:12px 15px;border:1px solid #ffffff55;border-radius:9px;font-weight:700}.active input{width:18px;height:18px}.notice{margin:16px 0;padding:13px 16px;border-radius:9px;font-weight:700}.notice.success{background:#dff5e9;color:#17643f}.notice.error{background:#fde6e8;color:#a32635}.loading{padding:60px;text-align:center}.panel{background:#fff;border:1px solid #dce5ea;border-radius:15px;padding:24px;margin-top:18px;box-shadow:0 8px 24px #1738480a}.title{display:flex;gap:13px;align-items:center;margin-bottom:20px}.title h2{margin:0;font-size:22px}.title p{margin:3px 0 0;color:#6d7e8c}.icon{display:grid;place-items:center;width:43px;height:43px;border-radius:11px;background:#e4f3f1;color:#16756f;font-size:23px}.grid{display:grid;gap:15px;margin-bottom:15px}.grid.three{grid-template-columns:repeat(3,1fr)}.grid.four{grid-template-columns:repeat(4,1fr)}label{display:flex;flex-direction:column;gap:7px;font-weight:700;color:#243b4b}input,textarea{width:100%;box-sizing:border-box;border:1px solid #cad8df;border-radius:8px;padding:11px 12px;font:inherit;color:#15293a;background:#fff}textarea{resize:vertical;line-height:1.5}input:focus,textarea:focus{outline:2px solid #65b8b455;border-color:#2f817d}label small{font-weight:400;color:#748694}.actions{display:flex;justify-content:flex-end;gap:12px;padding:20px 0 35px}.actions button{padding:12px 19px;border-radius:8px;font-weight:800}.primary{background:#267b77;color:#fff;border:1px solid #267b77}.primary:disabled{opacity:.6}.secondary{background:#fff;color:#263d4d;border:1px solid #cad8df}@media(max-width:900px){.hero{grid-template-columns:1fr}.grid.three,.grid.four{grid-template-columns:1fr 1fr}}@media(max-width:600px){.config-page{padding:12px}.grid.three,.grid.four{grid-template-columns:1fr}.actions{flex-direction:column-reverse}}
</style>
